module.exports = __webpack_public_path__ + "img/spiel7.1c606308.jpg";